import { useSuspenseQueries } from '@tanstack/react-query';
import { queryCategories } from '@/queries/categories';
import { filterStorefrontCategoryGroups } from '@/queries/categories/categories.visibility';
import { CategoryGroupKey, SIDEBAR_CATEGORY_GROUP_KEYS } from '@/queries/categories/types/categoryGroupKey';
import { sortCategoriesByOrder } from '@/utils/sortCategoriesByOrder';

export const useSidebarGroupCategories = () => {
  const results = useSuspenseQueries({
    queries: SIDEBAR_CATEGORY_GROUP_KEYS.map(groupKey =>
      queryCategories({ filters: { groupKey } }),
    ),
  });

  const dataByKey = Object.fromEntries(
    SIDEBAR_CATEGORY_GROUP_KEYS.map((key, i) => [key, results[i]?.data]),
  );

  const getSidebarCategories = (groupKey: CategoryGroupKey) =>
    sortCategoriesByOrder(filterStorefrontCategoryGroups(dataByKey[groupKey]?.items));

  return {
    beforeFavoritesCategories: getSidebarCategories(CategoryGroupKey.BEFORE_FAVORITES),
    afterFavoritesCategories: getSidebarCategories(CategoryGroupKey.AFTER_FAVORITES),
    otherCategories: getSidebarCategories(CategoryGroupKey.OTHER_CATEGORIES),
  };
};
